import { PAYMENT_GATEWAYS_API } from 'modules/profile/payment-gateways/api/payment-gateways-api'
import { PaymentRazorpayInterface } from 'modules/profile/payment-gateways/integrations/razorpay/types'
import httpClient from 'shared/utils/http-client'

export const razorpayConnect = (data: PaymentRazorpayInterface) =>
  httpClient.post(`${PAYMENT_GATEWAYS_API}/razorpay/connect`, data)

export const razorpayDisconnect = () =>
  httpClient.post(`${PAYMENT_GATEWAYS_API}/razorpay/disconnect`)
